import { render, staticRenderFns } from "./ModificarTarjetaForm.vue?vue&type=template&id=8adb5d8c"
import script from "./ModificarTarjetaForm.vue?vue&type=script&lang=js"
export * from "./ModificarTarjetaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports